// 02 — what we're figuring out. Being visibly undecided is what makes people
// answer, so this copy stays blunt (README).
import type { OpenQuestion } from '../types';
import { Medallion, Section, SectionHead } from './primitives';

export function SectionOpen({ items }: { items: OpenQuestion[] }) {
  return (
    <Section label="02 open questions">
      <SectionHead numeral="02 — what we're figuring out" title="still up in the air" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {items.map((item) => (
          <div
            key={item.q}
            style={{
              background: 'var(--deeper)',
              border: '1px solid rgba(127,227,232,0.2)',
              borderRadius: 12,
              padding: 20,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Medallion icon={item.icon} size={44} iconSize={24} color="var(--orange)" border="rgba(255,59,31,0.7)" />
              <div
                style={{
                  fontSize: 'clamp(22px,5.4vw,26px)',
                  fontWeight: 800,
                  letterSpacing: '-0.03em',
                  color: 'var(--cyan)',
                }}
              >
                {item.q}
              </div>
            </div>
            <div
              style={{
                fontSize: 18,
                lineHeight: 1.55,
                color: 'var(--body-2)',
                marginTop: 10,
                textWrap: 'pretty',
              }}
            >
              {item.a}
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}
